var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value || _vm.value === 0)?_c('el-tag',{attrs:{"type":_vm.tagType,"size":_vm.size}},[_vm._v(" "+_vm._s(_vm.getLabel)+" ")]):_c('span',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }